import { SettingsBandwidthSchedule } from 'mbs-ui-shared@models/settings-bandwidth-schedule';

export class SettingsBandwidthModel {
  enabled: boolean;
  limitUsingCloudStorage: number;
  limitUsingLocalStorage: number;
  enableSpecificSchedule: boolean;
  bandwidthSchedules: SettingsBandwidthSchedule[];

  constructor() {
    this.limitUsingCloudStorage = 0;
    this.limitUsingLocalStorage = 0;
    this.enableSpecificSchedule = false;
    this.enabled = false;
    this.bandwidthSchedules = [];
  }
}
